import { render, staticRenderFns } from "./orderPrice.vue?vue&type=template&id=ccf77c2c&scoped=true"
import script from "./orderPrice.vue?vue&type=script&lang=js"
export * from "./orderPrice.vue?vue&type=script&lang=js"
import style0 from "./orderPrice.vue?vue&type=style&index=0&id=ccf77c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf77c2c",
  null
  
)

export default component.exports